export const cartModal = (state) => state.cartModal;
export const loginModal = (state) => state.loginModal;
export const registerModal = (state) => state.registerModal;
export const resetPasswordModal = (state) => state.resetPasswordModal;
export const user = (state) => state.user;
export const orders = (state) => state.orders;
